import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { v4 } from 'uuid';

interface Props<T extends string> {
  options: {
    label: string;
    value: T;
  }[];
  current: T;
}


export default /*#__PURE__*/_defineComponent({
  __name: 't-dropdown',
  props: {
    options: null,
    current: null
  },
  emits: ["update:current"],
  setup(__props: any) {

const isOpen = ref(false);
const id = ref(v4());
const dropdownRef = ref<HTMLLegendElement | null>(null);

const close = (e: Event) => {
  if (dropdownRef.value !== e.target && !dropdownRef?.value?.contains(e.target as HTMLElement)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  window.addEventListener('click', close);
});

onUnmounted(() => {
  window.removeEventListener('click', close);
});




return { __sfc: true,isOpen, id, dropdownRef, close }
}

})